module.exports = __webpack_public_path__ + "files/c805e0c43f32709d25440015dd43ea58.svg";